import {
	AppRoutes,
} from '@/app/providers/app-router/enums'

import {
	AppRouterKeys,
} from '@/shared/model/constants'

import {
	combineRoutes,
} from '../helpers'
import {
	adminRoutes,
	authRoutes,
	baseRoutes,
} from './routes'

export const appRouteConfig = combineRoutes(
	baseRoutes,
	authRoutes,
	adminRoutes,

	{
		[AppRoutes.ALL_MATCH]: {
			path:     AppRouterKeys.ALL_MATCH,
			element:  <div>All Match</div>,
			authOnly: false,
		},
	},
)
